import { render, staticRenderFns } from "./ElectricLocomotivePanelRow.vue?vue&type=template&id=81da59e2&scoped=true&"
import script from "./ElectricLocomotivePanelRow.vue?vue&type=script&lang=ts&"
export * from "./ElectricLocomotivePanelRow.vue?vue&type=script&lang=ts&"
import style0 from "./ElectricLocomotivePanelRow.vue?vue&type=style&index=0&id=81da59e2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81da59e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCol,VContainer,VListItem,VRow,VSimpleTable})
